import React , {useState, useEffect,  Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Badge, Row, Col, Container, Card, Form, Button, ListGroup, OverlayTrigger, Popover, Tooltip, Carousel, InputGroup, FormControl, Table } from 'react-bootstrap'


import Moment from 'react-moment';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';

import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
    deviceDetect
  } from "react-device-detect";

export const CodeView = ({text_in}) => {

    const dispatch = useDispatch()



    useEffect(() => {
       

    }, [])



    return (

        <>
                <Card style={{
                    padding:'0px',
                    margin:'0px',
                    width: '100%',
                    maxWidth: '100%',
                    // height: '250px',
                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                    borderRadius: '15px',
                    border: '2px dashed #dee2e6',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        width: '100%',
                        height: '100%',
                        maxWidth: '100%',
                        overflow: 'auto',
                        padding: '5px 5px',
                    }}>
                        <SyntaxHighlighter
                            language="python"
                            wrapLongLines={true}
                            customStyle={{
                                margin: 0,
                                background: 'transparent',
                                maxWidth: '100%',
                                fontSize: isMobile ? '0.85rem' : '0.95rem',
                                lineHeight: 1.5
                            }}
                        >
                            {text_in}
                        </SyntaxHighlighter>
                    </div>
                </Card>
        </>
    )
}


export default CodeView